import { setBaseURL } from '../../../../utils/baseUrl';

export const setDeviceDataInLocal = (data, deviceType) => {
  if (data && data.devices[deviceType].APITunnel.Address) {
    if (!data.devices[deviceType].APITunnel.Address.startsWith('http')) {
      setBaseURL(`https://${data.devices[deviceType].APITunnel.Address}/graphql`);
    } else {
      setBaseURL(`${data.devices[deviceType].APITunnel.Address}/graphql`);
    }
  } else {
    localStorage.removeItem('BASE_URI');
  }
  if (data && data.devices[deviceType].AccessCookie.JWTCookie) {
    localStorage.setItem('COOKIE_ID', data.devices[deviceType].AccessCookie.JWTCookie);
  } else {
    localStorage.removeItem('COOKIE_ID');
  }
};
